import script from "./MeetingRoomModals.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingRoomModals.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingRoomModals.vue?vue&type=style&index=0&id=70f8857b&scoped=true&lang=scss"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f8857b"]])

export default __exports__